//#region Asset Imports

import 'devextreme/ui/progress_bar'

//#endregion

import { GRID_SERVICE_NAME } from "../../../services/grid"
import { IMRBaseComponent } from "../base"
import { BulkOperationController } from "./bulk-operation.controller"

//#region Asset Imports

import * as TEMPLATE from './bulk-operation.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrBulkOperation'

export class BulkOperationComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: BulkOperationController,
            template: TEMPLATE,
            services: [GRID_SERVICE_NAME]
        })
    }

}